import {DeviceType} from '../../incase-domain/common/DeviceType.enum';
import {
    ISetDesktopViewSelectedAction,
    ISetFullScreenAction,
    ISetSelectedDeviceTypeAction,
    SET_DESKTOP_VIEW_SELECTED,
    SET_FULLSCREEN,
    SET_SELECTED_DEVICE_TYPE,
} from './types/layout.action.types';

export const setDesktopViewSelected = (isDesktopViewSelected: boolean): ISetDesktopViewSelectedAction => ({
    type: SET_DESKTOP_VIEW_SELECTED,
    payload: isDesktopViewSelected,
});

export const setFullscreenAction = (isFullscreen: boolean): ISetFullScreenAction => ({
    type: SET_FULLSCREEN,
    payload: isFullscreen,
});

export const setSelectedDeviceTypeAction = (deviceType: DeviceType): ISetSelectedDeviceTypeAction => ({
    type: SET_SELECTED_DEVICE_TYPE,
    payload: deviceType,
});
